import { render, staticRenderFns } from "./PCSystemNotice.vue?vue&type=template&id=0d1e4ed3&scoped=true"
import script from "./PCSystemNotice.vue?vue&type=script&lang=js"
export * from "./PCSystemNotice.vue?vue&type=script&lang=js"
import style0 from "./PCSystemNotice.vue?vue&type=style&index=0&id=0d1e4ed3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1e4ed3",
  null
  
)

export default component.exports